import { EMPTY, of } from 'rxjs';
import { GuidService } from 'ui-components/services/guid-service';
import * as ConnectActions from '../../store/shipstation-connect/ss-connect.actions';
import * as Actions from './print.actions';
import { getLabelDownloadUrl, LABEL } from './constants';

export const handleQuickshipPrint = (
  fulfillmentPlanIds = [],
  fulfillmentIds = [],
  printSettings = {},
  defaultShouldAutoPrint = false,
  shouldShowPrintDialog = false,
) => {
  const hasPrinterId = !!printSettings?.id;

  // if autoprint and printerId, print
  if (defaultShouldAutoPrint && hasPrinterId) {
    const printJob = {
      requestId: GuidService.newGuid(),
      printer: printSettings,
      documentType: LABEL,
      ids: fulfillmentIds,
      fulfillmentPlanIds,
    };
    return of(ConnectActions.printDocumentRequest(printJob));
  }

  // if default setting is download, do that
  const shouldDownload = defaultShouldAutoPrint && printSettings?.name === 'download';
  if (shouldDownload) {
    return of(Actions.downloadLabel(fulfillmentIds, false));
  }

  // if user wants to see print modal, return obs of open print modal
  if (shouldShowPrintDialog) {
    const url = getLabelDownloadUrl(fulfillmentIds);
    return of(Actions.openPrintModal(url, LABEL, fulfillmentPlanIds, fulfillmentIds));
  }

  // here user does not want to see print modal, handle:
  if (!hasPrinterId) {
    return EMPTY;
  }

  const printJob = {
    requestId: GuidService.newGuid(),
    printer: printSettings,
    documentType: LABEL,
    ids: fulfillmentIds,
    fulfillmentPlanIds,
  };
  return of(ConnectActions.printDocumentRequest(printJob));
};
